<script lang="ts">

    import type {Community} from "../models/model";

    // export let filteredCommunities: Community[] = [];
    export let allCommunities: Community[] = [];

    import {_} from '../services/i18n';
    import SearchInput from "./SearchInput.svelte";
    import SearchResultItem from "./SearchResultItem.svelte";
    import {Utils} from "../util";
    import {Svrollbar, Svroller} from "svrollbar";

    //let communityData = [];
    let searchTerm = "";
    let isFocused: boolean = false;
    let showDropdown: boolean = false;




    let dropdownHeight = 0;
    let viewportHeight = 0;
   // let scrollerHeight = 0;

    let viewport: HTMLElement
    let contents: HTMLElement

    export let filteredItems:Community[] = [];
    export let selectedSearchCommunity:string;

    /*
        const handleInput = () => {
        return filteredItems = menuItems.filter(item => item.toLowerCase().match(inputValue.toLowerCase()));
    }
     */
    /*
    const handleInput = () => {
        return filteredItems = menuItems.filter(item => item.toLowerCase().match(inputValue.toLowerCase()));
    }

     */

    const itemSelected = (item) => {

        console.log('search result item selected key = ',item.key);
        searchTerm = Utils.chooseTranslation(item.name);
        console.log('search result item selected name = ',searchTerm);

        selectedSearchCommunity = item.key;

        showDropdown = false;
    }

    getAllCommunities();

    updateViewportHeight();
    window.addEventListener('resize', updateViewportHeight);

    $:{

        if (isFocused){
            showDropdown = true;
        }else{
            setTimeout(() => {
                showDropdown = false;
            },500);

        }
        if (searchTerm.length > 1) {
            //selectedSearchCommunity = undefined;
            //ideas for local search without api call:
            //Object.values(item.name).some(name => name.toLowerCase().includes(searchTerm));
            //filteredItems = menuItems.filter(item => item.toLowerCase().match(inputValue.toLowerCase()));
            //filteredItems = allCommunities.filter(item => nam)


            filteredItems = allCommunities.filter(item =>
                getLanguageValues(item.name).some(langValue =>
                    langValue.toLowerCase().includes(searchTerm.toLowerCase())
            ));


            if(filteredItems.length == 0){

            }else{

            }
           // console.log("filteredItems: ",filteredItems);
           // console.log("dropdownheight: ", dropdownHeight);
          //  scrollerHeight = 0; //reset is needed
          //  scrollerHeight = dropdownHeight;

        } else {
            if(searchTerm.length <= 1){
                selectedSearchCommunity = undefined;
                filteredItems = [];
               // scrollerHeight = (viewportHeight / 100) * 70; //70vh as initial value;

            }
            //output info that search is only working with > 1 length?
        }
    }

    async function getAllCommunities(){

        console.log("getAllCommunities()");
        if(mapType == 'pact'){
            allCommunities = await Utils.get(`/api/api/mfi/public/community?filter%5BhasPact%5D=1&isPaginated=0&lang=${lang}`);

        }else{
            allCommunities = await Utils.get(`/api/api/mfi/public/community?isPaginated=0&lang=${lang}`);

        }
    }

    function getLanguageValues(obj) {
        return Object.keys(obj).map(lang => obj[lang].toLowerCase());
    }

    function updateViewportHeight() {
        viewportHeight = window.innerHeight;
    }

</script>
<!--<div>isfocused: {isFocused}</div>-->
<!--<div>dheight = {dropdownHeight}, viewPortheight = {viewportHeight};}</div>-->
<div class="search-card w-100"  class:focused={isFocused}>

    <SearchInput bind:inputValue={searchTerm} bind:isFocused />

<!--
    {#key isFocused}
        {#if isFocused}
        -->
    <div class="dropdown-content-wrapper" class:focused={showDropdown}> <!-- style="opacity:{isFocused ? '1' : '0'}"-->
            <div class="dropdown-content" bind:clientHeight={dropdownHeight} bind:this={viewport}>
                <div bind:this={contents} >
                {#if filteredItems.length > 0 && searchTerm.length > 1}
                    {#each filteredItems as item}
                        <SearchResultItem selected="{item.key == selectedSearchCommunity}" item={item} on:itemClick={() =>itemSelected(item)}/>
                    {/each}
                {:else if filteredItems.length === 0  && searchTerm.length > 1}
                    <div class="no-results">{$_('search.noResults')}</div>
                {:else}
                    {#each allCommunities as item}
                        <SearchResultItem selected="{item.key == selectedSearchCommunity}"  item={item} on:itemClick={() => itemSelected(item)}/>
                    {/each}
                {/if}
                </div>
            </div>
           <Svrollbar {viewport} {contents} />
    </div>
<!--
        {/if}
    {/key}
-->

</div>

<style lang="scss">
  .search-card {
    border-radius: 10px;
    width: 97%;
    position: relative;
    display: inline-block;
    font-weight: normal;
    //overflow: hidden;
    text-align: left;
    white-space: nowrap;
    color: #000000;
    outline: none;
    background-color: #FFFFFF;
    z-index: 99;
    padding: 2rem;
    //overflow:hidden;

    &.focused{
    //overflow: visible;
    }
  }

  .dropdown-content-wrapper{
    margin-top:25px;
    //display: none;
    //background-color: #f6f6f6;
    min-width: 230px;
    width:100%;
    position: absolute;

    //border: 1px solid #ddd;
    z-index: 1;
    left:0;
    background:transparent;

   overflow: hidden;
    outline: 1px solid transparent;
   // background:red;


    //--svrollbar-track-background: ;
    --svrollbar-thumb-background: #054055;
    --svrollbar-thumb-opacity: 1;
    display:none;

    &.focused{
      display: block;
    }

  }

  .dropdown-content {
    box-shadow: 5px 10px 20px rgba(0, 0, 0, 0.1), -5px 10px 20px rgba(0, 0, 0, 0.1);
    width:100%;
    //position: absolute;
   // background:blue;
    //overflow: hidden;
    background:white;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;

    max-height: 70vh;

    overflow: scroll;
    /* hide scrollbar */
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .dropdown-content::-webkit-scrollbar {
    /* hide scrollbar */
    display: none;

  }

  /*hide box-shadow top */
  .dropdown-content:before {
    content: "";
    height: 10px;
    width: 100%;
    position: absolute;
    top: -10px;
    background: inherit;
    z-index: 2;
  }

  .focused{

    box-shadow: 5px 10px 20px rgba(0, 0, 0, 0.1), -5px 10px 20px rgba(0, 0, 0, 0.1);

  }

  .no-results{
    font-size:20px;
    padding: 10px 2rem;
    color:#000000;

  }
/*
  .show {
    display: block;
  }
*/
</style>
